import { Card, SVG } from "ui";

// icons
// import PhoneAndroidRoundedIcon from "@mui/icons-material/PhoneAndroidRounded"; // android
// import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded"; // iphone
// import LaptopChromebookRoundedIcon from "@mui/icons-material/LaptopChromebookRounded"; // web
import { playstore, web } from "utils/assets_exports/images";

const DevicesCards = () => {
    return (
        <div className="flex justify-center items-center gap-3 w-full px:2 md:px-4 py-4 ">
            {/* ios */}
            <Card
                className="flex flex-col justify-center items-center gap-2"
                style={{ width: 100 }}
            >
                {/* <PhoneIphoneRoundedIcon
                    fontSize="large"
                    className="dark:text-white"
                /> */}
                <SVG svg="apple" size={30} className="cursor-default" />
                <p className="dark:text-white text-sm">
                    <span className="font-medium">24</span> IOS
                </p>
            </Card>
            {/* android */}
            <Card
                className="flex flex-col justify-center items-center gap-2"
                style={{ width: 100 }}
            >
                {/* <PhoneAndroidRoundedIcon
                    fontSize="large"
                    className="dark:text-white"
                /> */}
                <img
                    src={playstore}
                    alt="play store"
                    style={{ width: 30, height: 30 }}
                />
                <p className="dark:text-white text-sm">
                    <span className="font-medium">0</span> Android
                </p>
            </Card>
            {/* web */}
            <Card
                className="flex flex-col justify-center items-center gap-2"
                style={{ width: 100 }}
            >
                {/* <LaptopChromebookRoundedIcon
                    fontSize="large"
                    className="dark:text-white"
                /> */}
                <img
                    src={web}
                    alt="play store"
                    style={{ width: 30, height: 30 }}
                />
                <p className="dark:text-white text-sm">
                    <span className="font-medium">8</span> Web
                </p>
            </Card>
        </div>
    );
};

export default DevicesCards;
